import initHomepageListingCarousels from '../../src/homepageListingCarousels'
import initRecentModules from '../../src/relatedListings/recentItemsModules'

document.addEventListener('DOMContentLoaded', () => {
  initHomepageListingCarousels()
  initRecentModules()
  if (document.querySelector('.vjs-intent-survey')) {
    import(/* webpackChunkName: "welcomeIntentSurvey" */ '../../src/welcomeIntentSurvey').then(module => {
      module.default()
    })
  }
  if (document.querySelector('.vjs-waiting-for-you')) {
    import(/* webpackChunkName: "welcomeWaitingForYou" */ '../../src/welcomeWaitingForYou').then(module => {
      module.default()
    })
  }
  if (document.querySelector('.vjs-price-drops')) {
    import(/* webpackChunkName: "welcomePriceDrops" */ '../../src/welcomePriceDrops').then(module => {
      module.default()
    })
  }
  if (document.querySelector('.vjs-gone-forever')) {
    import(/* webpackChunkName: "welcomeGoneForever" */ '../../src/welcomeGoneForever').then(module => {
      module.default()
    })
  }
  if (document.querySelector('.vjs-recent-search-matches')) {
    import(/* webpackChunkName: "welcomeRecentSearchMatches" */ '../../src/welcomeRecentSearchMatches').then(module => {
      module.default()
    })
  }
  import(/* webpackChunkName: "carousels" */ '../../src/carousels').then(module => {
    module.initHomepageMobileHeroCarousel()
  })
})
